<template>
    <div class="flex h-screen">
        <!-- Side menu -->
        <SideMenu />

        <!-- Contenu principal -->
        <div class="flex-1 p-6 ml-0 md:ml-64 overflow-auto transition-all duration-300 ">
            <router-view />
        </div>
    </div>
    <SignalerProbleme />
</template>

<script setup>
import SideMenu from '@/components/SideMenu.vue'
import SignalerProbleme from '@/components/SignalerProbleme.vue';
</script>
